export default __webpack_public_path__ + "static/media/117.736c7fc6.jpg";